import React, { useState, useEffect } from "react";
import Navbar from "../nav_bar/Navbar";
import "./RegisterPage.css";
import { GoogleLogin } from "@react-oauth/google";
import axiosInstance from "../../api/axiosInstance";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { MESSAGES } from "../../../common/messages";
import { TERMS_VERSION } from "../../../common/constants";


const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const RegisterPage = () => {

 const [step, setStep] = useState("signup");
 const [name, setName] = useState("");
 const [email, setEmail] = useState("");
 const [password, setPassword] = useState("");
 const [mobileNumber, setMobileNumber] = useState("");
 const [dialCode, setDialCode] = useState("+91");
 const [countryCodes, setCountryCodes] = useState([]);
 const [whatsappConsent, setWhatsappConsent] = useState(true);
 const [mobileError, setMobileError] = useState("");
 const [otp, setOtp] = useState("");
 const [isLinking, setIsLinking] = useState(false);
 const [googleId, setGoogleId] = useState(null);

 const [alertMessage, setAlertMessage] = useState("");
 const [showAlertModal, setShowAlertModal] = useState(false);

 const [toastMessage, setToastMessage] = useState("");
 const [showToast, setShowToast] = useState(false);

 const [loading, setLoading] = useState(false);
 const [resendCooldown, setResendCooldown] = useState(0);

 const [isSuspended, setIsSuspended] = useState(false);
 const [suspendReason, setSuspendReason] = useState("");

 const [acceptedTerms, setAcceptedTerms] = useState(false);
 const [acceptedGoogleTerms, setAcceptedGoogleTerms] = useState(false);

 const [showGoogleConsent, setShowGoogleConsent] = useState(false);
 const [pendingGoogleData, setPendingGoogleData] = useState(null);
 const [referralCode, setReferralCode] = useState(null);

 const navigate = useNavigate();
 const { login } = useAuth();
 const STATUS_LINK_REQUIRED = "LINK_REQUIRED";

 // ================= FETCH COUNTRY CODES =================
 useEffect(() => {
 axios.get(`${process.env.REACT_APP_BASE_URL}/public/country-codes`)
 .then(res => {
 const codes = res.data?.data || [];
 setCountryCodes(codes);
 })
 .catch(() => {});
 }, []);

 // ================= REFERRAL CODE CAPTURE =================
useEffect(() => {
 const params = new URLSearchParams(window.location.search);
 const ref = params.get("ref");

 if (ref) {


if (ref && ref.trim() !== "") {
 const normalizedRef = ref.trim().toUpperCase();



 setReferralCode(normalizedRef);
 localStorage.setItem("referralCode", normalizedRef);
} else {
 const storedRef = localStorage.getItem("referralCode");

 if (storedRef) {
 setReferralCode(storedRef.toUpperCase());
 }
}

 } else {
 // Load from storage if exists
 const storedRef = localStorage.getItem("referralCode");
 if (storedRef) {
 setReferralCode(storedRef);
 }
 }
}, []);

 // ================= CHECK EXISTING TOKEN =================
 useEffect(() => {
 const token = localStorage.getItem("token");
 const suspended = localStorage.getItem("isSuspended") === "true";

 if (token && !suspended) {

 navigate("/", { replace: true });
 }
 }, [navigate]);

 // ================= RESEND OTP TIMER =================
 useEffect(() => {
 let timer;
 if (resendCooldown > 0) {
 timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
 }
 return () => clearTimeout(timer);
 }, [resendCooldown]);

 const showAlert = (message) => {
 setAlertMessage(message);
 setShowAlertModal(true);
 };

 const showToastMessage = (message, duration = 3000) => {

 setToastMessage(message);
 setShowToast(true);
 setTimeout(() => setShowToast(false), duration);
 };

 // ================= EMAIL SIGNUP =================
 const handleEmailSignup = async () => {



 if (process.env.NODE_ENV !== "production") {

 }

 if (!name || !email || !password) {
 showAlert(MESSAGES.FILL_ALL_FIELDS);

 return;
 }

 if (!acceptedTerms) {
 showAlert("You must agree to the Terms of Service and Privacy Policy to continue.");

 return;
 }

 // Validate mobile number if provided
 if (mobileNumber) {
 const fullNumber = dialCode + mobileNumber;
 const e164Regex = /^\+[1-9]\d{1,14}$/;
 if (!e164Regex.test(fullNumber)) {
 setMobileError("Please enter a valid mobile number");

 return;
 }
 setMobileError("");
 }

 setLoading(true);
 try {
 const ref = referralCode || localStorage.getItem("referralCode");

 if (mobileNumber) {
 const fullNumber = dialCode + mobileNumber;
 // Use new mobile endpoint
 const signupRes = await axiosInstance.post("/auth_email/signup/request/mobile", {
 name,
 email,
 password,
 mobile_number: fullNumber,
 whatsapp_enabled: whatsappConsent,
 });
 } else {
 await axiosInstance.post("/auth_email/signup/request", null, {
 params: { name, email, password, userTimeZone, referralCode: ref },
 });
 }


 setStep("otp");
 setResendCooldown(30);
 showToastMessage("OTP sent to your email");

 } catch (err) {
 showAlert(err.response?.data?.message || MESSAGES.SIGNUP_FAILED);
 } finally {
 setLoading(false);

 }
 };

 // ================= OTP VERIFY =================
 const handleOtpVerify = async () => {



 if (process.env.NODE_ENV !== "production") {

 }

 if (!otp) {
 showAlert(MESSAGES.ENTER_OTP);

 return;
 }

 setLoading(true);
 try {
 if (isLinking) {


 const res = await axiosInstance.post("/auth/link/confirm", {
 email,
 otp,
 googleId,
 userTimeZone,
 });


 login(res.data);
 navigate("/", { replace: true });
 return;
 }

 await axiosInstance.post("/auth_email/signup/verify", null, {
 params: {
 email,
 otp,
 userTimeZone,
 referralCode: referralCode || localStorage.getItem("referralCode"),
 termsAccepted: acceptedTerms,
 privacyAccepted: acceptedTerms,
 termsVersion: TERMS_VERSION,
 ...(mobileNumber ? { whatsappEnabled: whatsappConsent } : {})
 },
});




 const loginRes = await axiosInstance.post("/auth_email/email_login", null, {
 params: { email, password, userTimeZone },
 });

 login(loginRes.data);
 navigate("/", { replace: true });

 } catch (err) {
 showAlert(err.response?.data?.message || MESSAGES.OTP_VERIFY_FAILED);
 } finally {
 setLoading(false);

 }
 };

 // ================= RESEND OTP =================
 const handleResendOtp = async () => {



 if (process.env.NODE_ENV !== "production") {

 }

 if (resendCooldown > 0) {

 return;
 }

 setLoading(true);
 try {
 if (isLinking) {

 await axiosInstance.post("/auth/link/resend-otp", { email, googleId });
 } else {

 await axiosInstance.post("/auth_email/signup/resend-otp", null, { params: { email } });
 }

 showToastMessage("OTP has been resent to your email");
 setResendCooldown(30);

 } catch (err) {
 showToastMessage(err.response?.data?.message || MESSAGES.OTP_RESEND_FAILED);
 } finally {
 setLoading(false);

 }
 };

 // ================= GOOGLE SIGNUP =================

const handleGoogleSuccess = async (cred) => {



 if (!cred?.credential) {
 showAlert("Google authentication failed. Please try again.");

 return;
 }

 setLoading(true);

 try {
 const res = await axiosInstance.post("/auth/google", {
 idToken: cred.credential,
 userTimeZone,
 });

 const backend = res.data?.data ?? res.data;

 // ================= EXISTING GOOGLE USER =================
 if (backend?.token && backend?.userType === "EXISTING_USER") {

 login(backend);
 navigate("/", { replace: true });
 return;
 }

 // ================= NEW GOOGLE USER =================
 if (backend?.userType === "NEW_USER") {


 setPendingGoogleData({
 googleId: backend.googleId,
 email: backend.email,
 name: backend.name,
 picture: backend.picture || null,
 });

 setAcceptedGoogleTerms(false);
 setShowGoogleConsent(true);
 return;
 }

 } catch (err) {

 const backend = err.response?.data;

 // ================= ACCOUNT LINK REQUIRED =================
 if (backend?.status === STATUS_LINK_REQUIRED) {



 if (!backend.email || !backend.googleId) {
 showAlert("Account linking failed. Please retry Google login.");
 return;
 }

 // Save linking data
 const linkingData = {
 email: backend.email,
 googleId: backend.googleId,
 name: backend.name || "",
 picture: backend.picture || null,
 };

 setPendingGoogleData(linkingData);
 setEmail(linkingData.email);
 setGoogleId(linkingData.googleId);

 showAlert("Email exists. Confirm account linking.");
 return;
 }

 showAlert(backend?.message || "Google signup failed");

 } finally {
 setLoading(false);

 }
};


 // ================= GOOGLE COMPLETE =================
 const handleGoogleCompleteSignup = async () => {



 if (!pendingGoogleData) {

 return;
 }

 if (!acceptedGoogleTerms) {
 showAlert("You must agree to the Terms of Service and Privacy Policy to continue.");

 return;
 }

 if (process.env.NODE_ENV !== "production") {

 }

 setLoading(true);

 try {
const res = await axiosInstance.post("/auth/google/complete", {
 googleId: pendingGoogleData.googleId,
 email: pendingGoogleData.email,
 name: pendingGoogleData.name,
 userTimeZone,
 picture: pendingGoogleData.picture,
 referralCode: referralCode || localStorage.getItem("referralCode"),
 termsAccepted: true,
 termsVersion: TERMS_VERSION,
 privacyAccepted: true,
 ...(mobileNumber ? { mobile_number: dialCode + mobileNumber, whatsapp_enabled: whatsappConsent } : {})
});




 login(res.data);
 setShowGoogleConsent(false);
 setAcceptedGoogleTerms(false);
 navigate("/", { replace: true });

 } catch (err) {
 showAlert(err.response?.data?.message || "Google signup failed");
 } finally {
 setLoading(false);

 }
 };

 // ================= ACCOUNT LINKING =================
const handleAccountLinking = async () => {


 if (!pendingGoogleData?.email || !pendingGoogleData?.googleId) {
 showAlert("Missing account linking data. Please retry Google login.");

 return;
 }

 setLoading(true);

 try {
 await axiosInstance.post("/auth/google/link-account", {
 email: pendingGoogleData.email,
 googleId: pendingGoogleData.googleId,
 });



 setShowAlertModal(false);
 setIsLinking(true);
 setStep("otp");

 showToastMessage("OTP sent. Verify to complete linking.", 4000);

 } catch (err) {
 showAlert(err.response?.data?.message || "Account linking failed");
 } finally {
 setLoading(false);

 }
};


 return (
 <div className="login-page">
 <Navbar />
 <div className="login-wrapper">
 <div className="form-container">
 <h2>Create Account</h2>
 <p className="subtitle">
 {MESSAGES.JOIN_TEXT} <b>{MESSAGES.SPEAK_BOLD_WITH_KK_TEXT}</b> {MESSAGES.START_IMPROVING}
 </p>

 <div className="google-wrapper">
 <GoogleLogin
 onSuccess={handleGoogleSuccess}
 onError={() => showAlert(MESSAGES.GOOGLE_SIGNUP_FAILED)}
 />
 </div>

 <div className="or-divider">OR</div>

 {step === "signup" ? (
 <>
 <div className="input-group">
 <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder=" " />
 <label>Full Name</label>
 </div>

 <div className="input-group">
 <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder=" " />
 <label>Email Address</label>
 </div>

 <div className="input-group">
 <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder=" " />
 <label>Password</label>
 </div>

 <div className="input-group mobile-input-group">
 <label className="mobile-label">Mobile Number (Optional)</label>
 <div className="mobile-row">
 <select
 className="country-code-select"
 value={dialCode}
 onChange={(e) => setDialCode(e.target.value)}
 >
 {countryCodes.length > 0 ? (
 countryCodes.map((c) => (
 <option key={c.id} value={c.dialCode}>
 {c.isoCode} {c.dialCode}
 </option>
 ))
 ) : (
 <option value="+91">IN +91</option>
 )}
 </select>
 <input
 type="tel"
 value={mobileNumber}
 onChange={(e) => {
 setMobileNumber(e.target.value.replace(/[^\d]/g, ""));
 setMobileError("");
 }}
 placeholder="0000000000"
 maxLength={15}
 className="mobile-number-input"
 />
 </div>
 {mobileError && <span className="field-error">{mobileError}</span>}
 </div>

<div className="input-group" style={{ marginTop: "15px" }}>
 <input
 type="text"
 value={referralCode || ""}
 onChange={(e) => {
 const code = e.target.value.toUpperCase();
 setReferralCode(code);

 if (code) {
 localStorage.setItem("referralCode", code);
 } else {
 localStorage.removeItem("referralCode");
 }
 }}
 placeholder=" "
 maxLength={12}
 />
 <label>Referral Code (Optional)</label>
</div>



 {/* ✅ Terms Checkbox */}
<div className="terms-container">
 <label className="terms-label">
 <input
 type="checkbox"
 checked={acceptedTerms}
 onChange={(e) => setAcceptedTerms(e.target.checked)}
 className="terms-checkbox"
 />
 <span>
 I agree to the{" "}
 <Link to="/terms-and-conditions" target="_blank" className="terms-link">
 Terms of Service
 </Link>{" "}
 and{" "}
 <Link to="/privacy-policy" target="_blank" className="terms-link">
 Privacy Policy
 </Link>.
 </span>
 </label>
</div>


 <button
 className="login-btn"
 onClick={handleEmailSignup}
 disabled={loading || !acceptedTerms}
 >
 {loading ? "Processing..." : "Create Account"}
 </button>
 </>
 ) : (
 <>
 <p className="subtitle">
 Enter the OTP sent to <b>{email}</b>
 </p>

 <div className="input-group">
 <input
 type="text"
 value={otp}
 onChange={(e) => setOtp(e.target.value)}
 placeholder=" "
 inputMode="numeric"
 maxLength={6}
 />
 <label>OTP Code</label>
 </div>

 <button className="login-btn" onClick={handleOtpVerify} disabled={loading}>
 {loading ? "Verifying..." : "Verify & Continue"}
 </button>

 <div style={{ textAlign: "center", marginTop: "12px" }}>
 <button className="btn-secondary" onClick={handleResendOtp} disabled={loading || resendCooldown > 0}>
 {resendCooldown > 0 ? `Resend OTP in ${resendCooldown}s` : "Resend OTP"}
 </button>
 </div>
 </>
 )}

 <div className="bottom-links">
 Already have an account? <Link to="/login">Login here</Link>
 </div>
 </div>
 </div>

 {showGoogleConsent && (
 <div className="modal-overlay">
 <div className="modal-box">
 <h3>Complete Your Registration</h3>
 <p>
 Welcome <b>{pendingGoogleData?.name}</b>
 </p>
 <p>Please accept our Terms to continue.</p>

 <div className="input-group mobile-input-group" style={{ marginTop: "15px" }}>
 <label className="mobile-label">Mobile Number (Optional)</label>
 <div className="mobile-row">
 <select
 className="country-code-select"
 value={dialCode}
 onChange={(e) => setDialCode(e.target.value)}
 >
 {countryCodes.length > 0 ? (
 countryCodes.map((c) => (
 <option key={c.id} value={c.dialCode}>
 {c.isoCode} {c.dialCode}
 </option>
 ))
 ) : (
 <option value="+91">IN +91</option>
 )}
 </select>
 <input
 type="tel"
 value={mobileNumber}
 onChange={(e) => {
 setMobileNumber(e.target.value.replace(/[^\d]/g, ""));
 setMobileError("");
 }}
 placeholder="0000000000"
 maxLength={15}
 className="mobile-number-input"
 />
 </div>
 {mobileError && <span className="field-error">{mobileError}</span>}
 </div>

 <div className="input-group" style={{ marginTop: "15px" }}>
 <input
 type="text"
 value={referralCode || ""}
 onChange={(e) => {
 const code = e.target.value.toUpperCase();
 setReferralCode(code);

 if (code) {
 localStorage.setItem("referralCode", code);
 } else {
 localStorage.removeItem("referralCode");
 }
 }}
 placeholder=" "
 maxLength={12}
 />
 <label>Referral Code (Optional)</label>
</div>


 <div className="terms-container" style={{ marginTop: "15px" }}>
 <label className="terms-label">
 <input
 type="checkbox"
 checked={acceptedGoogleTerms}
 onChange={(e) => setAcceptedGoogleTerms(e.target.checked)}
 className="terms-checkbox"
 />
 <span>
 I agree to the{" "}
 <Link to="/terms-and-conditions" target="_blank" className="terms-link">
 Terms of Service
 </Link>{" "}
 and{" "}
 <Link to="/privacy-policy" target="_blank" className="terms-link">
 Privacy Policy
 </Link>.
 </span>
 </label>
 </div>

 <div className="modal-actions" style={{ marginTop: "20px" }}>
 <button
 className="login-btn"
 onClick={handleGoogleCompleteSignup}
 disabled={loading || !acceptedGoogleTerms}
 >
 {loading ? "Processing..." : "Accept & Continue"}
 </button>
 </div>
 </div>
 </div>
)}


 {showAlertModal && (
 <div className="modal-overlay">
 <div className="modal-box">
 <h3>{isSuspended ? "Account Suspended" : "Alert"}</h3>
 <p>{isSuspended ? `Your account has been suspended. ` : alertMessage}</p>
 {suspendReason && (
 <p style={{ marginTop: "8px", fontWeight: "500" }}>
 <strong>Reason:</strong> {suspendReason}
 </p>
 )}
 <div className="modal-actions">
 <button
 className="btn-secondary"
 onClick={() => {
 setShowAlertModal(false);
 if (isSuspended) setIsSuspended(false);
 localStorage.removeItem("isSuspended");
 }}
 >
 Close
 </button>

 {!isSuspended && alertMessage === "Email exists. Confirm account linking." && (
 <button className="btn-primary" onClick={handleAccountLinking} disabled={loading}>
 Link Account
 </button>
 )}
 </div>
 </div>
 </div>
 )}

 {showToast && <div className="toast-notification">{toastMessage}</div>}

 {loading && (
 <div className="modal-overlay">
 <div className="modal-box" style={{ textAlign: "center" }}>
 <div className="loader"></div>
 <p>Processing, please wait...</p>
 </div>
 </div>
 )}
 </div>
 );
};

export default RegisterPage;
